import React from 'react';
import officeBg from '../assets/office-bg.png';

export default function SideBackground({ children, style = {}, ...props }) {
  return (
    <div
      style={{
        flex: 1,
        background: `url(${officeBg}) center center/cover no-repeat`,
        position: 'relative',
        minHeight: '100vh',
        display: 'block',
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
} 